export const MODAL_ARIA_LABEL = 'Travel Bot Chat Dialog Modal';
export const MODAL_ARIA_TITLE = 'Travel Bot Chat Dialog';
export const getDisplayConfig = (viewType, isMobile) => {
  const displayConfig = {
    LANDING: {
      chatContainerHeight: '85%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile,
        scrimColor: 'medium',
        zIndex: 1000
      }
    },
    CHECKOUT: {
      chatContainerHeight: '85%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile
      }
    },
    DRIVE: {
      chatContainerHeight: '60%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile,
        scrimColor: 'medium',
        zIndex: 1000
      }
    },
    FLY: {
      chatContainerHeight: '60%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile,
        scrimColor: 'medium',
        zIndex: 1000
      }
    },
    ITINERARY: {
      chatContainerHeight: '90%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile,
        scrimColor: 'medium',
        zIndex: 1000
      }
    },
    PACKAGE: {
      chatContainerHeight: '60%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile
      }
    },
    PORTAL: {
      chatContainerHeight: '85%',
      dialogOverlayProps: {
        ariaDescription: 'Dialog to chat with Penny',
        ariaTitle: 'Penny Chat Bot Dialog',
        fullWidth: isMobile
      }
    },
    STAYDETAILS: {
      chatContainerHeight: '90%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile,
        scrimColor: 'medium',
        zIndex: 1000
      }
    },
    STAYLISTINGS: {
      chatContainerHeight: '60%',
      dialogOverlayProps: {
        ariaDescription: MODAL_ARIA_LABEL,
        ariaTitle: MODAL_ARIA_TITLE,
        fullWidth: isMobile,
        scrimColor: 'medium',
        zIndex: 1000
      }
    }
  };
  // Ensure viewType has a valid display config
  const config = displayConfig[viewType];
  if (!config) {
    throw new Error(`No display configuration found for viewType: ${viewType}. ` + 'Add configuration to displayConfig object in /react-components/penny-chat-bot/src/config/displayConfig.ts. ');
  }
  return config;
};